<div class="modal-header">
    <h3 class="modal-title">Usos de máquina para data {{$uso.data.date | date:'dd/MM/yyyy'}} {{$uso.usos[0].maquina.descricao}}</h3>
  </div>
  <div class="modal-body">
    <p ng-show="$uso.ready && !$uso.usos.length">Não foi encontrado nenhum uso</p>
    <table class="table table-hover" ng-show="$uso.ready && $uso.usos.length">
      <thead>
        <tr>
          <th>Operador</th>
          <th>Operação</th>
          <th>Hora Inicial</th>
          <th>Hora Final</th>
          <th>Horímetro Inicial</th>
          <th>Horímetro Final</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="uso in $uso.usos">
          <td>{{uso.operador.nome}}</td>
          <td>{{uso.operacao.descricao}}</td>
          <td>{{uso.hora_inicial_tempo}}</td>
          <td>{{uso.hora_final_tempo}}</td>
          <td>{{uso.hora_inicial_mec | number:1}}</td>
          <td>{{uso.hora_final_mec | number:1}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="modal-footer">
    <button class="btn btn-primary" type="button" ng-click="$uso.close()">Ok</button>
  </div>
